import { Typography, } from "@bracket/ui";
import { usePlatform, } from "@store";
import type { FunctionComponent, } from "react";
import styled from "styled-components";



export declare type ChainBadgeProps = {
	chainId: number;
};



export const ChainBadge: FunctionComponent<ChainBadgeProps> = ({
	chainId,
}) => {

	const {
		ready,
		chains,
	} = usePlatform();

  if(!ready) {
    return null;
  }

  const chain = chains[chainId];

  if(!chain) {
		throw new Error(`ChainBadge: chain ${chainId} not found`);
	}

	return (
		<Base>
			<Inner>
				<img src={chain.logo} alt={chain.name} />
				<Typography variant="p">{chain.name}</Typography>
			</Inner>
		</Base>
	);
};

const Base = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

const Inner = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-direction: column;
	> img {
		height: 25;
	}
	p {
		opacity: 0.35;
	}
`;
